import React, {useMemo} from 'react';
import {useIntl} from 'react-intl';

import Button from 'brandComponents/Button';
import {useHeaderCtx} from 'brandComponents/Header/HeaderCtx';
import ShowOrHideOnBreakpoint from 'brandComponents/Responsive/ShowOrHideOnBreakpoint';

import {INavigationItemListViewAllProps} from './INavigationItemListViewAll';
import messages from './messages';

const NavigationItemListViewAll = ({url, show}: INavigationItemListViewAllProps) => {
	const intl = useIntl();
	const viewAllMessage = intl.formatMessage(messages.navigationViewAll);
	const headerCtx = useHeaderCtx(true);

	const onClick = useMemo(() => (
		headerCtx?.isInHeaderContext
			? headerCtx.handleNavigationVisibility
			: () => {}
	), [headerCtx?.isInHeaderContext]);

	if (show === 'none') {
		return null;
	}

	const query = show.startsWith('<') || show.startsWith('>') ? show : '';

	return (
		<ShowOrHideOnBreakpoint
			classNames="view-all"
			as="li"
			query={query}
		>
			<Button url={url} title={viewAllMessage} classNames="view-all-button" variant="anything" onClick={onClick} >
				{viewAllMessage}
			</Button>
		</ShowOrHideOnBreakpoint>
	);
};

export default NavigationItemListViewAll;
